export default "__VITE_ASSET__CeebrQsz__"